export default {
  ENTRYPOINT: '/api/v1',
  ROUTES: {
    CONSTRUCTIONS_PATH: '/constructions',
    CONSTRUCTION_PATH: '/constructions/:id',
    ORDERS_PATH: '/orders',
    ORDER_CALL_PATH: '/order_call'
  }
}


// WEBPACK FOOTER //
// ./app/javascript/app/constants/api.js